import { TProjectsListState } from 'shared/reducers';

export const selectPage = (state: TProjectsListState) => {
  return state.page;
};
